import React, { useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate } from "react-router-dom";

const cities = [
  'Casablanca', 'Rabat', 'Meknes', 'Marrakech', 'Essaouira', 'Fes',
  'Tanger', 'Agadir', 'Al Hoceima', 'Chefchaouen', 'Nador', 'Kenitra',
  'Assilah', 'Tetouan', 'Ifrane', 'Dakhla'
];

const getYouTubeVideoId = (url) => {
  const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|shorts\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

const NewPlan = () => {
  const [info, setInfo] = useState({
    city: "", title: "", youtubeUrl: "",
    description: "", order: "", featured: false,
  });
  const [collapsed, setCollapsed] = useState(false);
  const [focused, setFocused] = useState(null);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setInfo((prev) => ({ ...prev, [id]: value }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setInfo((prev) => ({
      ...prev,
      [name]: value === "true" ? true : value === "false" ? false : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch("https://api.moroccool.com/api/plans", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(info),
      });
      navigate("/plans");
    } catch (err) {
      console.error(err);
    }
  };

  const videoId = getYouTubeVideoId(info.youtubeUrl);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,300&family=DM+Mono:wght@400;500&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .np-layout {
          display: flex;
          min-height: 100vh;
          background: #FAFAFA;
          font-family: 'DM Sans', sans-serif;
        }

        .np-main {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .np-content {
          flex: 1;
          padding: 40px 48px 60px;
          overflow-y: auto;
          max-width: 1300px;
          width: 100%;
          margin: 0 auto;
        }

        /* ── Header ── */
        .np-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 48px;
          padding-bottom: 32px;
          border-bottom: 1px solid #E8E8E8;
        }

        .np-header-left {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .np-eyebrow {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #7C3AED;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .np-eyebrow::before {
          content: '';
          display: inline-block;
          width: 20px;
          height: 1px;
          background: #7C3AED;
        }

        .np-title {
          font-size: 36px;
          font-weight: 600;
          color: #0A0A0A;
          letter-spacing: -0.03em;
          line-height: 1.1;
          margin-top: 6px;
        }

        .np-subtitle {
          font-size: 14px;
          color: #888;
          font-weight: 400;
          margin-top: 6px;
          letter-spacing: -0.01em;
        }

        /* ── Grid ── */
        .np-grid {
          display: grid;
          grid-template-columns: 1fr 360px;
          gap: 24px;
          align-items: start;
        }

        /* ── Card ── */
        .np-card {
          background: #FFFFFF;
          border: 1px solid #EBEBEB;
          border-radius: 16px;
          padding: 36px;
        }

        .np-card-label {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: #AAAAAA;
          margin-bottom: 28px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .np-card-label::after {
          content: '';
          flex: 1;
          height: 1px;
          background: #F0F0F0;
        }

        /* ── Form Row ── */
        .np-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 16px;
        }

        .np-row.full { grid-template-columns: 1fr; }

        /* ── Field ── */
        .np-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .np-field label {
          font-size: 12px;
          font-weight: 500;
          color: #555;
          letter-spacing: 0.01em;
        }

        .np-input,
        .np-select,
        .np-textarea {
          width: 100%;
          background: #FAFAFA;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          padding: 11px 14px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          color: #0A0A0A;
          outline: none;
          transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
          -webkit-appearance: none;
          appearance: none;
        }

        .np-input::placeholder,
        .np-textarea::placeholder {
          color: #C0C0C0;
        }

        .np-input:focus,
        .np-select:focus,
        .np-textarea:focus {
          border-color: #7C3AED;
          background: #FFFFFF;
          box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.08);
        }

        .np-select {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 14px center;
          padding-right: 36px;
          cursor: pointer;
        }

        .np-textarea {
          resize: vertical;
          min-height: 120px;
          line-height: 1.6;
        }

        /* ── Submit ── */
        .np-submit-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 28px;
          padding-top: 28px;
          border-top: 1px solid #F0F0F0;
        }

        .np-btn-primary {
          background: #7C3AED;
          color: white;
          border: none;
          border-radius: 10px;
          padding: 12px 28px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: -0.01em;
          cursor: pointer;
          transition: background 0.15s, transform 0.1s, box-shadow 0.15s;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .np-btn-primary:hover {
          background: #6D28D9;
          box-shadow: 0 4px 16px rgba(124, 58, 237, 0.28);
          transform: translateY(-1px);
        }

        .np-btn-primary:active {
          transform: translateY(0);
          box-shadow: none;
        }

        .np-btn-secondary {
          background: transparent;
          color: #888;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          padding: 12px 20px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
          transition: border-color 0.15s, color 0.15s;
          letter-spacing: -0.01em;
        }

        .np-btn-secondary:hover {
          border-color: #AAAAAA;
          color: #333;
        }

        /* ── Preview Card ── */
        .np-preview-card {
          background: #FFFFFF;
          border: 1px solid #EBEBEB;
          border-radius: 16px;
          overflow: hidden;
          position: sticky;
          top: 24px;
        }

        .np-video-wrapper {
          width: 100%;
          aspect-ratio: 16/9;
          background: #F5F5F5;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .np-video-wrapper iframe {
          width: 100%;
          height: 100%;
          border: none;
          display: block;
        }

        .np-video-placeholder {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          color: #C8C8C8;
        }

        .np-video-placeholder-icon {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #EDEDED;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .np-video-placeholder span {
          font-size: 12px;
          font-family: 'DM Mono', monospace;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }

        .np-preview-body {
          padding: 24px;
        }

        .np-preview-city {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #7C3AED;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .np-preview-title {
          font-size: 18px;
          font-weight: 600;
          color: #0A0A0A;
          letter-spacing: -0.02em;
          line-height: 1.25;
          margin-bottom: 10px;
          min-height: 22px;
        }

        .np-preview-desc {
          font-size: 13px;
          color: #888;
          line-height: 1.65;
          min-height: 40px;
        }

        .np-preview-meta {
          display: flex;
          gap: 8px;
          margin-top: 16px;
          padding-top: 16px;
          border-top: 1px solid #F0F0F0;
          flex-wrap: wrap;
        }

        .np-tag {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.08em;
          padding: 4px 10px;
          border-radius: 100px;
          text-transform: uppercase;
        }

        .np-tag-purple {
          background: rgba(124, 58, 237, 0.08);
          color: #7C3AED;
        }

        .np-tag-amber {
          background: rgba(217, 119, 6, 0.08);
          color: #D97706;
        }

        .np-tag-gray {
          background: #F5F5F5;
          color: #888;
        }

        /* ── Arrow icon for button ── */
        .np-btn-arrow {
          font-size: 16px;
          line-height: 1;
          transition: transform 0.15s;
        }
        .np-btn-primary:hover .np-btn-arrow {
          transform: translateX(2px);
        }

        /* ── Responsive ── */
        @media (max-width: 900px) {
          .np-grid { grid-template-columns: 1fr; }
          .np-preview-card { position: static; }
          .np-content { padding: 24px 20px 40px; }
          .np-title { font-size: 28px; }
        }
      `}</style>

      <div className="np-layout">
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

        <div className="np-main">
          <Navbar />

          <div className="np-content">

            {/* Header */}
            <div className="np-header">
              <div className="np-header-left">
                <div className="np-eyebrow">New Entry</div>
                <h1 className="np-title">Travel Plan</h1>
                <p className="np-subtitle">Add a new video plan to your collection</p>
              </div>
            </div>

            {/* Grid */}
            <div className="np-grid">

              {/* Form */}
              <div className="np-card">
                <div className="np-card-label">Plan Details</div>

                <form onSubmit={handleSubmit}>
                  <div className="np-row">
                    <div className="np-field">
                      <label>City</label>
                      <select
                        className="np-select"
                        name="city"
                        value={info.city}
                        onChange={handleSelectChange}
                        required
                      >
                        <option value="" disabled>Select a city</option>
                        {cities.map((c) => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </select>
                    </div>

                    <div className="np-field">
                      <label>Plan Title</label>
                      <input
                        className="np-input"
                        id="title"
                        type="text"
                        placeholder="Enter an engaging title"
                        value={info.title}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="np-row full" style={{ marginBottom: 16 }}>
                    <div className="np-field">
                      <label>YouTube URL</label>
                      <input
                        className="np-input"
                        id="youtubeUrl"
                        type="text"
                        placeholder="https://www.youtube.com/watch?v=..."
                        value={info.youtubeUrl}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="np-row full" style={{ marginBottom: 16 }}>
                    <div className="np-field">
                      <label>Description</label>
                      <textarea
                        className="np-textarea"
                        id="description"
                        placeholder="Write a compelling description for this travel plan..."
                        value={info.description}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="np-row">
                    <div className="np-field">
                      <label>Display Order</label>
                      <input
                        className="np-input"
                        id="order"
                        type="number"
                        placeholder="1"
                        min={1}
                        value={info.order}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="np-field">
                      <label>Featured</label>
                      <select
                        className="np-select"
                        name="featured"
                        value={info.featured.toString()}
                        onChange={handleSelectChange}
                        required
                      >
                        <option value="false">No</option>
                        <option value="true">Yes — Featured</option>
                      </select>
                    </div>
                  </div>

                  <div className="np-submit-row">
                    <button type="submit" className="np-btn-primary">
                      Create Plan
                      <span className="np-btn-arrow">→</span>
                    </button>
                    <button
                      type="button"
                      className="np-btn-secondary"
                      onClick={() => navigate("/plans")}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>

              {/* Preview */}
              <div className="np-preview-card">
                <div className="np-video-wrapper">
                  {videoId ? (
                    <iframe
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title="YouTube video preview"
                      allowFullScreen
                    />
                  ) : (
                    <div className="np-video-placeholder">
                      <div className="np-video-placeholder-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <polygon points="5 3 19 12 5 21 5 3" />
                        </svg>
                      </div>
                      <span>Preview</span>
                    </div>
                  )}
                </div>

                <div className="np-preview-body">
                  {info.city && (
                    <div className="np-preview-city">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                      </svg>
                      {info.city}
                    </div>
                  )}

                  <div className="np-preview-title">
                    {info.title || <span style={{ color: '#D0D0D0', fontWeight: 400 }}>Plan title</span>}
                  </div>

                  <div className="np-preview-desc">
                    {info.description || <span style={{ color: '#D8D8D8' }}>Description will appear here...</span>}
                  </div>

                  {(info.featured || info.order) && (
                    <div className="np-preview-meta">
                      {info.featured && <span className="np-tag np-tag-amber">Featured</span>}
                      {info.order && <span className="np-tag np-tag-gray">#{info.order}</span>}
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPlan;